import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { Navbar } from './NavBar';
import {makeStyles} from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  fullHeightFlex: {
    display: "flex",
    flex: "1 1 auto",
    flexDirection: "column",
  }, 
  mainContainer: {
    // backgroundColor: theme.palette.background.default,
    display: "flex",
    flex: "1 1 auto",
    flexDirection: "column",
    height: "100%",
    overflowX: "hidden",
  }
}))

export const Layout = (props) => {
  const classes = useStyles();
  return (
    <div className={classes.mainContainer}>
      <Navbar/>
      <div className={classes.fullHeightFlex}>
        {props.children}
      </div>
    </div>
  )
}

// export class Layout extends Component {
//   static displayName = Layout.name;

//   render () {
//     return (
//       <div>
//         <NavMenu />
//         <Container>
//           {this.props.children}
//         </Container>
//       </div>
//     );
//   }
// }
